import { UnauthInfiniteQueryOptions } from '@/api';
import { filledInfiniteQueryOptions } from '@/utils/filledInfiniteQueryOptions';

import type { CampaignListItem } from '../_components/CampaignCard';
import { CAMPAIGN_PAGE_SIZE } from '../constants';

const CAMPAIGN_PHASE_TAB_LIST = [
  'UPCOMING',
  'RECRUITING',
  'CLOSED',
] as const satisfies readonly CampaignListItem['campaignPhase'][];

export type CampaignPhaseTab = (typeof CAMPAIGN_PHASE_TAB_LIST)[number];

export const CAMPAIGN_PHASE_SEARCH_PARAM = 'phase';

export const toCampaignPhaseTab = (value?: string | null): CampaignPhaseTab =>
  CAMPAIGN_PHASE_TAB_LIST.find((phaseTab) => phaseTab === value) ??
  'RECRUITING';

export const buildCampaignListOptions = (campaignPhaseTab: CampaignPhaseTab) =>
  filledInfiniteQueryOptions(
    UnauthInfiniteQueryOptions['get:/wello/v2/allows/gift-trial/campaigns']({
      query: { campaignPhaseTab, page: 1, size: CAMPAIGN_PAGE_SIZE },
    }),
  );
